module.exports = __webpack_public_path__ + "img/11.2cca31c5.png";